import axios from 'axios';

export default class FaasData {
  constructor({ baseURL }) {
    this.baseURL = baseURL;
  }

  async getFaasIdAndName(brandId) {
    const result = await axios.get(`${this.baseURL}/${brandId}/faas-data`);
    return result.data;
  }
}
